import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import awaitingImage from "../img/awaiting.png"

function Image({ image, alt, ...rest }) {
  if (image && image.id) {
    const url = `https://ht.clockworkbee.co.uk/assets/${image.id}?quality=75&width=800&fit=contain`

    if (image.imageFile) {
      const im = getImage(image.imageFile)
      return <GatsbyImage image={im} alt="" />
    }
    // this is an image coming from Netlify CMS
    return <img src={url} {...rest} alt={alt} />
  }
  return (
    <img src={awaitingImage} {...rest} alt={alt} />

    // <div className="bg-gray-100 p-4 text-gray-600">Image not defined.</div>
  )
}

export default Image
